import type { IFutureFlag } from '../types';

import { FutureFlag } from '../types';

export const GEMX_FEATURE_FLAG = 'GEMX_FEATURE_FLAG';
export const DEFAULT_FUTURE_FLAG: IFutureFlag = {
  [FutureFlag.MAKE_WINNER_BUTTON]: false,
  [FutureFlag.PRICE_TESTING]: false,
  [FutureFlag.LANGUAGE_SETTING]: false,
  [FutureFlag.FILTER_BY_SHOPIFY_PAGE_ID]: false,
  [FutureFlag.DEV_MODE]: false,
  [FutureFlag.PRICING_COUPON]: false,
  [FutureFlag.HOTFIX_TEMPLATE_LOADING]: false,
  [FutureFlag.AFTER_MAKE_WINNER]: false,
  [FutureFlag.HEATMAP_BETA]: false,
  [FutureFlag.HEATMAP_V1]: false,
  [FutureFlag.HEATMAP_V2]: false,
  [FutureFlag.HEATMAP_V3]: false,
  [FutureFlag.HEATMAP_MOCK_DATA]: false,
};
